import React, { Component } from 'react';
import PercentChart from './PercentChart';
import { get } from 'lodash';

export default class RAROC extends Component {
  render() {
    return (
      <PercentChart
        title='RAROC'
        upDownPercent='11.1%'
        // percent={`${get(this.props.data, 'bankwide[0].raroc', 0).toFixed(2)}%`}
        percent={`${23.01.toFixed(2)}%`}
      />
    );
  }
}



// WEBPACK FOOTER //
// src/pages/Raroc/Dashboard/OverviewWholeBank/components/PercentChart/RAROC.js